import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PlatformEnum} from "../../enums/platform.enum";
import {environment} from "../../../../environments/environment";
import {PwaService} from "../../services/pwa/pwa.service";

@Component({
  selector: 'app-pwa-installation-dialog',
  templateUrl: './pwa-installation-dialog.component.html',
  styleUrls: ['./pwa-installation-dialog.component.scss'],
})
export class PwaInstallationDialogComponent {

  platform: PlatformEnum;
  alertMessage: string;
  PlatformEnum = PlatformEnum;
  environment = environment;
  window = window;

  constructor(
    public dialogRef: MatDialogRef<PwaInstallationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {},
    private pwaService: PwaService
  ) {
    this.platform = this.pwaService.detectMobileOS();
    switch (this.platform) {
      case PlatformEnum.android:
        this.alertMessage = "disponibile su Google Play";
        break;
      case PlatformEnum.ios:
        this.alertMessage = "disponibile su App Store";
        break;
      case PlatformEnum.web:
        this.alertMessage = 'scaricabile sul tuo dispositivo'
        break;
    }
  }
}
